import imagePrevie from './imagePrevie.vue'

imagePrevie.install = function(Vue) {
  Vue.component(imagePrevie.name,imagePrevie)
}

export default imagePrevie


// WEBPACK FOOTER //
// ./src/packge/index.js